<template>
  <div class="tusd-wrap wrap-image login-register">
  	<div class="return-btn" @click="goBack"></div>
    <div class="login-register-header">
    	<div class="logo"></div>
    	<p>会员注册</p>
    </div>
    <div class="account-wrap">
    	<div class="wrap-item">
    		<span class="item-label phone-label">邮箱： </span>
    		<span class="unit send-code" @click="sendCode">{{sendTxt}}</span>
    		<input type="text"   v-model="register.Email" placeholder="请输入邮箱" />
    	</div>
    	<div class="wrap-item">
    		<span class="item-label verify-label">验证码： </span>
    		<input type="text" v-model="register.Code" placeholder="请输入验证码" />
    	</div>
    	<div class="wrap-item">
    		<span class="item-label reset-label">密码： </span>
    		<input type="password" maxlength="20" v-model="register.password" placeholder="请输入您的密码" />
    	</div>
    	<div class="wrap-item">
    		<span class="item-label reset-label">确认密码： </span>
    		<input type="password" maxlength="20" v-model="register.RePassword" placeholder="请确认您的密码" />
    	</div>
    	<div class="tusd-btn login-register-btn" @click="goRegister">注册</div>
    </div>
    <div class="copyright">Copyright © {{year}} Company. All rights reserved.</div>
    <cube-popup :mask="false" type="prompt-popup" ref="promptPopup">{{popupTxt}}</cube-popup>
  </div>
</template>

<script>
export default {
  name: 'register',
  data(){
  	return {
		year:new Date().getFullYear(),
  		register:{
  			Email:'',
  			Code:'',
			password:'',
			RePassword:'',
			AccoutType:_ACCOUNTTYPY_,
        	SmsType:1
  		},
  		params:{},
  		send:false,
  		sendTxt:'验证码',
  		click:false,
  		popupTxt:''
  	}
  },
  methods:{
  	goBack(){
  		this.$router.push({name:this.params.back})
  	},
  	sendCode(){
		let that=this;
  		if(that.send){
  			return false;
  		}
  		if(!that.register.Email){
			that.$message.popup("请输入邮箱", 1000);
  			return false
  		}
  		// if(!that.verify.verifyPhone(that.register.phone)){
		// 	that.$message.popup("请输入正确的手机号", 1000);
  		// 	return false
		//   }
  		let data={
  			Email:that.register.Email,
  			AccoutType:_ACCOUNTTYPY_,
        	SmsType:1
  		};
		that.$api.sendEmailCode(data).then((res)=>{
		        that.$message.popup("发送成功",1000);
				that.send = true
  				that.common.countdown(that.$store.state.sendTime,that,'sendTxt',() => {
					that.send=false;
  					that.sendTxt = '验证码'
  				})
		});		
  	},
  	goRegister(){
		let that=this;
  		if(!that.register.Email){
			that.$message.popup("请输入邮箱", 1000);
  			return false
  		}
  		// if(!that.verify.verifyPhone(that.register.phone)){
		// 	that.$message.popup("请输入正确的手机号", 1000);
  		// 	return false
  		// }
  		if(!that.register.Code){
			that.$message.popup("请输入验证码", 1000);
  			return false
  		}
  		if(!that.register.password){
			that.$message.popup("请输入您的密码", 1000);
  			return false
  		}
  		if(!that.verify.verifyPassword(that.register.password)){
			that.$message.popup("6~20位数字、字母或字符", 1000);
  			return false
  		}
  		if(that.register.password !==that.register.RePassword){
			that.$message.popup("两次密码不一致", 1000);
  			return false
		  }
		that.$api.register(that.register).then((res)=>{
			that.$message.popup("注册成功", 1000);
			that.goBack()
		})
  	}
  },
  created(){
  	this.params = this.$store.state.routerStore.register
  }
}
</script>

<style lang="less" scoped>
	.phone-label,
	.verify-label{
		width: 92px!important;
	}
	.send-code + input{
		width: calc(100% - 136px)!important;
	}
	@media screen and (max-width:360px ) {
		.login-register{
			padding:12% 6px 0px;
			.login-register-btn{
				margin-top: 15%;
			}
		}
	}
</style>